import React, { createContext, useState, useContext, useEffect } from "react";
import { getCookie } from "../components/auth/login/GetCookie";
import Cookies from 'js-cookie';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [userRoles, setUserRoles] = useState([]);

    // Cookie configuration options
  const cookieOptions = {
    //secure: process.env.NODE_ENV === 'production', // Secure in production
    //sameSite: 'strict',
     sameSite: 'Lax',   // ✅ best choice for HTTP
    path: '/',
    expires: 1 // 1 day expiration
  };

  useEffect(() => {
   
      const token = Cookies.get('token');
        const storedRoles = Cookies.get('roles');
        const storedUser = Cookies.get('user');
    if (token && storedRoles) {
  
      setUserRoles(JSON.parse(storedRoles));
        if (storedUser && storedUser !== "undefined") {
            setUser(JSON.parse(storedUser));
          }
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
      setUserRoles([]);
    }

    setLoading(false); // Mark loading as complete
  }, []); // Empty dependency array ensures this runs once on mount

  const login = (token, userData,roles) => {

     // Set all auth data in cookies
      Cookies.set('token', token, cookieOptions);
      Cookies.set('roles', JSON.stringify(roles), cookieOptions);
      Cookies.set('user', JSON.stringify(userData), cookieOptions);
      
    setUser(userData);
    //  setUserRoles(roles);
    setIsAuthenticated(true);
  };

  const logout = () => {

    // Remove all auth cookies
    Cookies.remove('token', cookieOptions);
    Cookies.remove('roles', cookieOptions);
    Cookies.remove('user', cookieOptions);

      // Determine where user logged in from
  const loginOrigin = Cookies.get("loginOrigin");
  Cookies.remove("loginOrigin");

    setUser(null);
    setUserRoles([]);
    setIsAuthenticated(false);
       const BASE_URL =process.env.REACT_APP_ADMIN_lOGOUT_URL
       const BASE_URL_BUYER =process.env.REACT_APP_BUYER_URL

      // Redirect based on origin
  if (loginOrigin === 'admin') {
    window.location.href = BASE_URL; // Admin login page
  } else {
    window.location.href = BASE_URL_BUYER; // Buyer login page
  }
  };


  return (
    <AuthContext.Provider
      value={{ isAuthenticated, loading, user, userRoles, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export default AuthProvider;
